var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Field, TextArea, Checkbox, RadioButton, Select, Multiselect, Button, Fieldset, } from '../index';
import FormStep from 'ui-component-library/uhmse/EpiForms/FormStep';
var isValidFormElement = function (element) {
    switch (element.type) {
        case Checkbox:
        case Field:
        case TextArea:
        case RadioButton:
        case Button:
        case Select:
        case Multiselect:
        case Fieldset:
        case FormStep:
            return true;
        default:
            return false;
    }
};
/**
 * Custom hook for cloning pand rendering children with custom props in form
 */
export var useChildClones = function (showError, visibleFields) {
    var formFieldNameCounter = {};
    var renderChildren = function (children, initialValues, resetForm, onFieldChange) {
        if (!children) {
            return null;
        }
        var renderedChildren = React.Children.map(children, function (child) {
            var props = child && child.props ? __assign({}, child.props) : {};
            if (!React.isValidElement(child)) {
                return child;
            }
            if (isValidFormElement(child)) {
                var name_1 = props.name;
                props.onFieldChange = onFieldChange;
                props.resetForm = resetForm;
                props.showError = showError;
                props.visibleFields = visibleFields;
                if (initialValues[name_1]) {
                    props.defaultValue = initialValues[name_1];
                }
                if (!formFieldNameCounter[name_1]) {
                    formFieldNameCounter[name_1] = 1;
                }
                else {
                    formFieldNameCounter[name_1] += 1;
                }
            }
            if (props && props.children) {
                props.children = renderChildren(props.children, initialValues, resetForm, onFieldChange);
            }
            return React.cloneElement(child, props);
        });
        return renderedChildren.length === 1
            ? renderedChildren[0]
            : renderedChildren;
    };
    return [renderChildren, formFieldNameCounter];
};
